const authState = {
    loading: true,
    user: '',
    token: localStorage.getItem('token')
}
const authReducer = (state = authState, action) => {
    switch (action.type) {
        case 'REQUEST_AUTH':
            return Object.assign({}, state, {
                loading: true
            })

        case 'REQUEST_AUTH_FAIL':
        case 'LOGOUT':
            return Object.assign({}, state, {
                user: '',
                loading: false,
                token: ''
            })

        case 'REQUEST_AUTH_SUCCESS':
            return Object.assign({}, state, {
                user: action.payload.user,
                token: action.payload.token,
                loading: false,
            })

        default:
            return state
    }
}

export default authReducer


// WEBPACK FOOTER //
// ./src/reducers/authReducer.js